import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Man2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"man_2"}/>
}
